(() => {
	"use strict";

	document.addEventListener("DOMContentLoaded", () => {
		/*======================================
	ページ遷移フェード
	======================================*/
		const FADE_DURATION = 300;
		const FADE_EXCLUDE_CLASS = "is-no-fade"; //フェードさせたくない要素

		const revealPage = () => {
			document.body.classList.remove("js-fade");
		};

		if (document.readyState === "complete") {
			revealPage();
		} else {
			window.addEventListener("load", revealPage, { once: true });
		}

		window.addEventListener("pageshow", revealPage);

		document.addEventListener("click", (event) => {
			if (event.defaultPrevented) return;
			if (event.button !== 0) return;
			if (
				event.metaKey ||
				event.ctrlKey ||
				event.shiftKey ||
				event.altKey
			) {
				return;
			}

			const target = event.target;

			if (!(target instanceof Element)) return;

			const link = target.closest("a");

			if (!link) return;
			if (link.classList.contains(FADE_EXCLUDE_CLASS)) return;
			if (link.hasAttribute("target")) return;
			if (link.hasAttribute("download")) return;

			const href = link.getAttribute("href");

			if (!href) return;
			if (href.startsWith("#")) return;
			if (/^(mailto:|tel:|javascript:)/i.test(href)) return;

			const url = new URL(href, window.location.href);
			const currentPath = window.location.pathname.replace(/\/$/, "");
			const targetPath = url.pathname.replace(/\/$/, "");

			const isExternal = url.origin !== window.location.origin;
			const isSamePageHash =
				targetPath === currentPath &&
				url.search === window.location.search &&
				Boolean(url.hash);

			if (isExternal || isSamePageHash) return;

			event.preventDefault();
			document.body.classList.add("js-fade");

			window.setTimeout(() => {
				window.location.href = url.href;
			}, FADE_DURATION);
		});

		/*======================================
	慣性スクロール
	======================================*/
		window.lenis = new Lenis({
			autoRaf: true,
		});

		/*======================================
	トップへ戻る
	======================================*/

		const pagetopBtn = document.querySelector(".js-scrollTop");

		if (pagetopBtn) {
			pagetopBtn.addEventListener("click", () => {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			});
		}

		/*======================================
	SNSロゴ非表示
	======================================*/
		const fixedElement = document.querySelector(".js-logo-hidden");
		const targetElement = document.querySelector(".footer__sns");

		if (fixedElement && targetElement && "IntersectionObserver" in window) {
			const fixedHeight = fixedElement.offsetHeight;

			const observer = new IntersectionObserver(
				([entry]) => {
					// フッターが「固定要素の領域に入りそう」なら隠す
					fixedElement.classList.toggle(
						"is-hidden",
						entry.isIntersecting,
					);
				},
				{
					// 画面下端から fixedHeight 分だけ“判定ライン”を上にずらす
					root: null,
					threshold: 0,
					rootMargin: `0px 0px -${fixedHeight}px 0px`,
				},
			);

			observer.observe(targetElement);
		}
		/*======================================
	スムーススクロール
	======================================*/
		const headerOffset = 0;

		const getLayoutTop = (el) => {
			let top = 0;
			let node = el;

			while (node instanceof HTMLElement) {
				top += node.offsetTop;
				node = node.offsetParent;
			}

			return top;
		};

		const smoothTo = (hash) => {
			const el = document.querySelector(hash);

			if (!(el instanceof HTMLElement)) return;

			const top = Math.max(getLayoutTop(el) - headerOffset, 0);

			window.scrollTo({
				top,
				behavior: "smooth",
			});
		};

		document.querySelectorAll('a[href*="#"]').forEach((a) => {
			a.addEventListener("click", (e) => {
				const url = new URL(
					a.getAttribute("href"),
					window.location.href,
				);

				const sameOrigin = url.origin === window.location.origin;
				const samePath =
					url.pathname.replace(/\/$/, "") ===
					window.location.pathname.replace(/\/$/, "");

				if (!sameOrigin || !samePath || !url.hash) return;

				e.preventDefault();
				history.pushState(null, "", url.hash);
				smoothTo(url.hash);
			});
		});

		//別ページから来たとき
		if (window.location.hash) {
			smoothTo(window.location.hash);
		}

		/*======================================
	ハンバーガーメニュー
	======================================*/
		const NAV = document.querySelector(".js-menu-area");
		const TOGGLE = document.querySelector(".js-menu-btn");
		const BODY = document.body;
		let y = 0;

		// 閉じる
		function menuClose(restoreScroll = true) {
			TOGGLE.setAttribute("aria-expanded", "false");
			TOGGLE.setAttribute("aria-label", "MENU");
			NAV.setAttribute("aria-hidden", "true");

			BODY.style.position = "";
			BODY.style.top = "";

			if (restoreScroll) {
				window.scrollTo(0, y);
			}

			// アニメーション用class付加
			TOGGLE.classList.add("-close");
			TOGGLE.addEventListener(
				"animationend",
				() => {
					TOGGLE.classList.remove("-close");
				},
				{ once: true },
			);
		}

		// 開く
		function menuOpen() {
			y = window.scrollY;
			TOGGLE.setAttribute("aria-expanded", "true");
			TOGGLE.setAttribute("aria-label", "CLOSE");
			NAV.setAttribute("aria-hidden", "false");
			BODY.style.position = "fixed";
			BODY.style.top = `-${y}px`;
		}

		TOGGLE.addEventListener("click", () => {
			if (TOGGLE.getAttribute("aria-expanded") === "true") {
				menuClose();
			} else {
				menuOpen();
			}
		});

		// 閉じるevent（アンカーリンク）
		document
			.querySelectorAll(".mobile-menu__primaryLink")
			.forEach((link) => {
				link.addEventListener("click", (event) => {
					const href = link.getAttribute("href");

					if (!href) {
						menuClose();
						return;
					}

					const url = new URL(href, window.location.href);
					const isSamePage =
						url.pathname === window.location.pathname &&
						url.search === window.location.search &&
						url.hash;

					// 同一ページ内アンカー
					if (isSamePage) {
						event.preventDefault();

						const target = document.querySelector(url.hash);

						// メニューだけ閉じる（元の位置には戻さない）
						menuClose(false);

						if (!target) {
							return;
						}

						// body fixed解除後にアンカーへ移動
						requestAnimationFrame(() => {
							requestAnimationFrame(() => {
								target.scrollIntoView({
									behavior: "smooth",
									block: "start",
								});
							});
						});

						return;
					}

					// 別ページ遷移は通常どおり閉じる
					menuClose();
				});
			});
		/*======================================
	フッターアニメーション
	======================================*/
		const footerAnime = document.querySelector(".footerAnime");
		const footerContainer = footerAnime?.querySelector(
			".footerAnime__container",
		);
		const footerPaths = footerContainer?.querySelectorAll(
			"svg path, svg line, svg polyline, svg polygon, svg circle, svg rect",
		);

		if (footerAnime && footerContainer && footerPaths?.length) {
			footerPaths.forEach((path) => {
				const length = path.getTotalLength();

				path.style.strokeDasharray = `${length}`;
				path.style.strokeDashoffset = `${length}`;
				path.style.strokeLinecap = "round";
				path.style.strokeLinejoin = "round";
				path.classList.add("is-draw-animation");
			});

			let hasStartedFooterAnimation = false;

			const startFooterAnimation = () => {
				if (hasStartedFooterAnimation) return;

				hasStartedFooterAnimation = true;
				footerAnime.classList.add("is-started");
			};

			if ("IntersectionObserver" in window) {
				const footerObserver = new IntersectionObserver(
					([entry]) => {
						if (!entry.isIntersecting) return;

						startFooterAnimation();
						footerObserver.disconnect();
					},
					{
						root: null,
						threshold: 0.25,
					},
				);

				footerObserver.observe(footerAnime);
			} else {
				const checkFooterAnimation = () => {
					if (hasStartedFooterAnimation) return;

					const rect = footerAnime.getBoundingClientRect();
					const triggerLine = window.innerHeight * 0.85;

					if (rect.top <= triggerLine && rect.bottom >= 0) {
						startFooterAnimation();
						window.removeEventListener(
							"scroll",
							checkFooterAnimation,
						);
						window.removeEventListener(
							"resize",
							checkFooterAnimation,
						);
						window.removeEventListener(
							"load",
							checkFooterAnimation,
						);
					}
				};

				window.addEventListener("load", checkFooterAnimation);
				window.addEventListener("scroll", checkFooterAnimation, {
					passive: true,
				});
				window.addEventListener("resize", checkFooterAnimation);

				checkFooterAnimation();
			}
		}
	});
})();
